
import * as z from "zod";

export const clientFormSchema = z.object({
  school_id: z.string().regex(/^\d+$/, "School ID must contain only numbers"),
  nama_sekolah: z.string().min(1, "School name is required"),
});

export type ClientFormValues = z.infer<typeof clientFormSchema>;
